import axios from "axios";
import { AppConstants } from "@/constants/AppConstants";

/**
 * API通信用クライアント（トークン認証付き）
 *
 * axios通信用のクライアントです。
 * サーバーサイドでトークンの検証をするため、HTTPヘッダにトークン情報を付与しています
 * ※トークン認証が必要ない場合は、こちらではなくapiClientを使用してください
 *
 */
const apiClientAuth = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  },
  withCredentials: true,
});

apiClientAuth.interceptors.request.use((config) => {
  const token = localStorage.getItem(AppConstants.TOKEN_SESSION_NAME);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClientAuth;
